(function () {
  if (!location.pathname.startsWith("/pages/onadm")) return;

  // ===== CONFIG =====
  const MEILI_HOST = "https://ms-d9843601d0a3-38732.nyc.meilisearch.io";
  const MEILI_KEY  = "54477b5fb8a1a2a5c259aab2123cc6596b265cee42772bd87dc25fa144345d23";
  const INDEX_NAME = "mrmagazine_dvds";
  const PER_PAGE   = 70;
  // ==================

  let page = 1;
  let lastHits = [];
  let lastTotal = 0;

  const form      = document.getElementById("onadm-form");
  const resultsEl = document.getElementById("onadm-results");
  const statusEl  = document.getElementById("onadm-status");
  const prevBtn   = document.getElementById("onadm-prev");
  const nextBtn   = document.getElementById("onadm-next");
  const pageLabel = document.getElementById("onadm-page-label");
  const toggleBtn = document.getElementById("onadm-view-toggle");

  function escapeHtml(s) {
    return String(s ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function money(n) {
    const x = Number(n);
    return Number.isFinite(x) ? `$${x.toFixed(2)}` : "";
  }

  function mapSort(val) {
    switch (val) {
      case "price_asc":  return ["price:asc"];
      case "price_desc": return ["price:desc"];
      default:           return undefined; // relevance
    }
  }

  function getMode() {
    return localStorage.getItem("onadm_view_mode") || "grid"; // grid | list
  }

  function setMode(mode) {
    localStorage.setItem("onadm_view_mode", mode);
    if (toggleBtn) toggleBtn.textContent = mode === "grid" ? "View: Grid" : "View: List";
    // re-render with current hits; no refetch
    render(lastHits);
  }

  async function meiliSearch(body) {
    const url = `${MEILI_HOST.replace(/\/+$/, "")}/indexes/${INDEX_NAME}/search`;
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${MEILI_KEY}`
      },
      body: JSON.stringify(body)
    });

    if (!res.ok) {
      const t = await res.text();
      throw new Error(t || res.statusText);
    }

    return res.json();
  }

  // === RENDERERS ===

  function renderGrid(hits) {
    const grid = document.createElement("div");
    grid.className = "onadm-grid";

    for (const it of hits) {
      const card = document.createElement("article");
      card.className = "onadm-card";

      card.innerHTML = `
        <a class="onadm-card-link" href="${escapeHtml(it.item_url)}" target="_blank" rel="noopener">
          <img class="onadm-card-thumb" src="${escapeHtml(it.thumbnail)}" loading="lazy" alt="">
          <div class="onadm-card-title">${escapeHtml(it.title)}</div>
        </a>
        <div class="onadm-card-bottom">
          <span class="onadm-card-price">${money(it.price)}</span>
          <a class="onadm-card-btn" href="${escapeHtml(it.item_url)}" target="_blank" rel="noopener">View</a>
        </div>
      `;

      grid.appendChild(card);
    }

    resultsEl.appendChild(grid);
  }

  function renderList(hits) {
    const list = document.createElement("div");
    list.className = "onadm-list";

    for (const it of hits) {
      const row = document.createElement("div");
      row.className = "onadm-row";

      row.innerHTML = `
        <a class="onadm-row-link" href="${escapeHtml(it.item_url)}" target="_blank" rel="noopener">
          <img class="onadm-row-thumb" src="${escapeHtml(it.thumbnail)}" loading="lazy" alt="">
          <div class="onadm-row-main">
            <div class="onadm-row-title">${escapeHtml(it.title)}</div>
            <div class="onadm-row-meta">${money(it.price)}</div>
          </div>
        </a>
        <a class="onadm-row-btn" href="${escapeHtml(it.item_url)}" target="_blank" rel="noopener">View</a>
      `;

      list.appendChild(row);
    }

    resultsEl.appendChild(list);
  }

  function render(hits) {
    resultsEl.innerHTML = "";

    if (!hits || !hits.length) {
      resultsEl.innerHTML = '<p class="onadm-empty">No results.</p>';
      return;
    }

    if (getMode() === "list") renderList(hits);
    else renderGrid(hits);
  }

  async function run() {
    const q = (form.elements.q.value || "").toString();
    const qHas = !!q.trim();

    // show totals only when searching
    statusEl.textContent = qHas ? "Loading…" : "";

    const sort = mapSort(form.elements.sort.value);

    const body = {
      q,
      limit: PER_PAGE,
      offset: (page - 1) * PER_PAGE
    };
    if (sort) body.sort = sort;

    const data = await meiliSearch(body);

    lastHits = data.hits || [];
    lastTotal = data.estimatedTotalHits || 0;

    render(lastHits);

    const from = lastTotal ? (page - 1) * PER_PAGE + 1 : 0;
    const to   = Math.min(page * PER_PAGE, lastTotal);

    if (qHas) {
  if (!lastTotal) {
    statusEl.textContent = "No results";
  } else {
    // If Meilisearch caps estimatedTotalHits at 1000, display "over 1000"
    const totalLabel = (lastTotal === 1000) ? "over 1000" : String(lastTotal);
    statusEl.textContent = `Showing ${from}–${to} of ${totalLabel}`;
  }
} else {
  statusEl.textContent = "";
}


    pageLabel.textContent = `Page ${page}`;
    prevBtn.disabled = page <= 1;
    nextBtn.disabled = page * PER_PAGE >= lastTotal;
  }

  form.addEventListener("submit", (e) => {
    e.preventDefault();
    page = 1;
    run().catch(err => { statusEl.textContent = `Error: ${err.message || err}`; });
  });

  prevBtn.addEventListener("click", () => {
    if (page > 1) {
      page--;
      run().catch(err => { statusEl.textContent = `Error: ${err.message || err}`; });
    }
  });

  nextBtn.addEventListener("click", () => {
    page++;
    run().catch(err => { statusEl.textContent = `Error: ${err.message || err}`; });
  });

  if (toggleBtn) {
    toggleBtn.textContent = getMode() === "grid" ? "View: Grid" : "View: List";
    toggleBtn.addEventListener("click", () => {
      setMode(getMode() === "grid" ? "list" : "grid");
    });
  }

function applyUrlParamsToForm() {
  const params = new URLSearchParams(window.location.search);

  const qParam = params.get("q");
  if (qParam !== null && form?.elements?.q) {
    form.elements.q.value = qParam;
  }

  const sortParam = params.get("sort");
  if (sortParam !== null && form?.elements?.sort) {
    const ok = Array.from(form.elements.sort.options)
      .some(o => o.value === sortParam);
    if (ok) form.elements.sort.value = sortParam;
  }
}

  
  // initial load
  applyUrlParamsToForm();
run().catch(err => { statusEl.textContent = `Error: ${err.message || err}`; });

})();
